import { Formik, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import TextField from "./controls/TextField";
import { OperacionUnitariaSchema } from "../data/OperacionUnitariaSchema";
import { isInvalid } from "../utils/forms";
import TextareaField from "./controls/TextareaField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";
import { useDialog } from "./controls/Dialog";
import { listarRelacionesOperacionUnitaria } from "../utils/data";

export function OperacionUnitariaForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  disabled,
}) {
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const dialog = useDialog({ showing: false, variant: "warning" });
  const handleDeleteClick = (form) => (event) => {
    event.preventDefault();
    const item = tramiteForm.values.operacionesUnitarias[page];
    if (!!item) {
      const relacionados = listarRelacionesOperacionUnitaria(item, tramiteForm);
      if (
        relacionados.productosElaborados.length > 0 ||
        relacionados.sustanciasQuimicas.length > 0 ||
        relacionados.fuentesEfluentesLiquidos.length > 0 ||
        relacionados.residuosSolidosUrbanos.length > 0 ||
        relacionados.residuosPeligrosos.length > 0 ||
        relacionados.residuosPatogenicos.length > 0 ||
        relacionados.ductos.length > 0
      ) {
        dialog.display(
          t("operacionUnitariaForm.dialog.remove.title"),
          <>
            <p>{t("operacionUnitariaForm.dialog.remove.message")}</p>
            <ul>
              {relacionados.productosElaborados.length > 0 && (
                <li>
                  <div>{t("tramite.productosElaborados")}</div>
                  <ul>
                    {relacionados.productosElaborados.map((producto) => (
                      <li>{producto.nombre}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.sustanciasQuimicas.length > 0 && (
                <li>
                  <div>{t("tramite.sustanciasQuimicas")}</div>
                  <ul>
                    {relacionados.sustanciasQuimicas.map((sustancia) => (
                      <li>
                        {sustancia.nombreComercial}&nbsp;(
                        {sustancia.nombreQuimico})
                      </li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.fuentesEfluentesLiquidos.length > 0 && (
                <li>
                  <div>{t("tramite.fuentesEfluentesLiquidos")}</div>
                  <ul>
                    {relacionados.fuentesEfluentesLiquidos.map((fuente) => (
                      <li>{fuente.nombre}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.residuosSolidosUrbanos.length > 0 && (
                <li>
                  <div>{t("tramite.residuosSolidosUrbanos")}</div>
                  <ul>
                    {relacionados.residuosSolidosUrbanos.map((residuo) => (
                      <li>{residuo.descripcion}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.residuosPatogenicos.length > 0 && (
                <li>
                  <div>{t("tramite.residuosPatogenicos")}</div>
                  <ul>
                    {relacionados.residuosPatogenicos.map((residuo) => (
                      <li>{residuo.descripcion}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.residuosPeligrosos.length > 0 && (
                <li>
                  <div>{t("tramite.residuosPeligrosos")}</div>
                  <ul>
                    {relacionados.residuosPeligrosos.map((residuo) => (
                      <li>{residuo.descripcion}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.ductos.length > 0 && (
                <li>
                  <div>{t("tramite.chimeneas")}</div>
                  <ul>
                    {relacionados.ductos.map((ducto) => (
                      <li>
                        {ducto.numeroDucto}&nbsp;-&nbsp;{ducto.referencia}
                      </li>
                    ))}
                  </ul>
                </li>
              )}
            </ul>
          </>,
          t("operacionUnitariaForm.dialog.remove.accept"),
          t("operacionUnitariaForm.dialog.remove.decline"),
          (event) => {
            console.log(page);
            remove(page);
            dialog.close();
          },
          (event) => {
            dialog.close();
          },
        );
      }
    } else {
      console.log(page);
      remove(page);
    }
  };
  const handleSubmitClick = (form) => (event) => {
    event.preventDefault();
    form.submitForm();
  };
  const handleCancelClick = (form) => (event) => {
    event.preventDefault();
    select(0);
  };
  return (
    <Formik
      initialValues={value}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
      enableReinitialize={true}
      validationSchema={OperacionUnitariaSchema}
    >
      {(form) => (
        <>
          {dialog.component}
          <Grid as={<Panel />} className="formulario embebido">
            <Row>
              <Col>
                <Label>{t("operacionUnitariaForm.titulo")}</Label>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <TextField
                  id="operacionUnitaria_nombre"
                  name="nombre"
                  label={t("operacionUnitaria.nombre")}
                  value={form.values?.nombre}
                  onChange={(event) => {
                    form.handleChange(event);
                  }}
                  isInvalid={isInvalid("nombre", form)}
                  error={t(form.errors.nombre)}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <TextareaField
                  id="operacionUnitaria_descripcion"
                  name="descripcion"
                  label={t("operacionUnitaria.descripcion")}
                  rows={12}
                  value={form.values?.descripcion}
                  onChange={(event) => {
                    form.handleChange(event);
                  }}
                  isInvalid={isInvalid("descripcion", form)}
                  error={t(form.errors.descripcion)}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row style={{ display: "flex", flexWrap: "wrap" }}>
              <Col lg={7}>
                <Pagination
                  sm
                  page={page}
                  pages={pages}
                  onChange={(event) => select(event.target.value)}
                />
              </Col>
              <Col lg={5}>
                <span
                  style={{
                    float: "right",
                    alignContent: "center",
                  }}
                >
                  {page !== -1 && (
                    <Button
                      sm
                      variant="success"
                      value={t("operacionUnitariaForm.nuevo")}
                      onClick={(event) => {
                        event.preventDefault();
                        select(-1);
                      }}
                      disabled={disabled}
                    />
                  )}
                  {page !== -1 && (
                    <Button
                      sm
                      variant="danger"
                      value={t("operacionUnitariaForm.eliminar")}
                      onClick={handleDeleteClick(form)}
                      disabled={disabled}
                    />
                  )}
                  <Button
                    sm
                    variant="primary"
                    value={t("operacionUnitariaForm.guardar")}
                    onClick={handleSubmitClick(form)}
                    disabled={disabled}
                  />
                  {page === -1 && pages > 0 && (
                    <Button
                      sm
                      variant="default"
                      value={t("operacionUnitariaForm.cancelar")}
                      onClick={handleCancelClick(form)}
                      disabled={disabled}
                    />
                  )}
                </span>
              </Col>
            </Row>
          </Grid>
        </>
      )}
    </Formik>
  );
}
